const header = [
	{
		'name': "Commodity",
		'id': 0,
		'isActive': false
	},
	{
		'name': "Details",
		'id': 1,
		'isActive': false
	},
	{
		'name': "Evaluation",
		'id': 2,
		'isActive': false
	}
];

const evaluation = [
	{
		'name': 'All',
		'id': 1,
		'isActive': false,
		'value': 'total',
		'grade': 0
	},
	{
		'name': 'Praise',
		'id': 2,
		'isActive': false,
		'value': 'good',
		'grade': 1
	},
	{
		'name': 'Average',
		'id': 3,
		'isActive': false,
		'value': 'medium',
		'grade': 2
	},
	{
		'name': 'Bad review',
		'id': 4,
		'isActive': false,
		'value': 'bad',
		'grade': 3
	}
];
export {
	header,
	evaluation
}
